import { createContext } from 'react';
export const CarouselContext = /*#__PURE__*/createContext({
  carouselContainer: null,
  elementWidth: null,
  carouselWidthPx: null,
  variant: null,
  bleedElements: null,
  isHovering: null,
  showControls: null
});